import Vue from 'vue';
import Cookie from '@/services/cookie';

export default {
    getMe(context) {
        const url = 'v1/me';
        return Vue.$axios.$get(url).then((response) => {
            context.dispatch('me/storeAllUserData', response.data, { root: true });
            return response;
        }).catch(() => {
            Cookie.deleteToken();
        });
    },

    authenticated() {
        const url = 'v1/me/authenticated';
        return Vue.$axios.$get(url).then(() => {
        }).catch(() => {
            Cookie.deleteToken();
        });
    },

    getCustomAttributes(context, {group}) {
        const url = `v1/me/custom-fields?group=${group}`;
        return Vue.$axios.$get(url);
    },

    updateCustomAttributes(context, {id, value}) {
        const url = `v1/me/custom-field/${id}`;
        return Vue.$axios.$put(url, { value });
    },

    checkEmail(context, { email }) {
        const url = `v1/users/check-email?email=${encodeURIComponent(email)}`;
        return Vue.$axios.$get(url).then((response) => {
            return response;
        });
    },

    updateMyDetails({ dispatch }, data) {
        const url = 'v1/me';
        return Vue.$axios.$put(url, data).then((response) => {
            dispatch('storeAllUserData', response.data);
            return response;
        });
    },

    updateMyEmail(context, { email, password }) {
        const url = 'v1/me/email';
        return Vue.$axios.$put(url, { email, password });
    },

    storeAllUserData(context, data) {
        const user = data;

        if (user.attributeOptions) {
            context.commit('STORE_ATTRIBUTE_OPTION', user.attributeOptions);
            delete user.attributeOptions;
        }

        if (user.education) {
            context.commit('STORE_EDUCATION', user.education);
            delete user.education;
        }

        if (user.reference) {
            context.commit('STORE_REFERENCE', user.reference);
            delete user.reference;
        }

        if (user.workExperience) {
            context.commit('STORE_WORK_EXPERIENCE', user.workExperience);
            delete user.workExperience;
        }

        if (user.workLocations) {
            context.commit('STORE_WORK_LOCATION', user.workLocations);
            delete user.workLocations;
        }

        if (user.desiredOccupations) {
            context.commit('STORE_DESIRED_OCCUPATION', user.desiredOccupations);
            delete user.desiredOccupations;
        }

        if (user.resumes) {
            context.commit('STORE_RESUME', user.resumes);
            delete user.resumes;
        }

        context.commit('STORE_USER', user);
    },

    deleteAccount() {
        const url = 'v1/me/delete-account';
        return Vue.$axios.$post(url);
    },

    downloadProfilePDF() {
        const url = 'v1/me/profile/pdf';
        return Vue.$axios.get(url, {
            responseType: 'blob',
            timeout: 30000,
        });
    },

    getJobApplication(context, { job_uuid, data }) {
        const url = `v1/users/seeker-applications/${job_uuid}`;
        return Vue.$axios.$get(url, { params: data});
    },
 
    updateDetails(context, formData) {
        let data = new FormData();

        Object.entries(formData).forEach((item) => {
            if (item[0] === 'additional_docs') {
                if (Array.isArray(item[1])) {
                    item[1].forEach((o) => {
                        if (o) {
                            data.append('additional_docs[]', o);
                        }
                    });
                } else {
                    if (item[1]) {
                        data.append('additional_docs[0]', item[1]);
                    }
                }
            }
            else if (item[0] === 'custom_fields') {
                item[1].forEach((o, i) => {
                    data.append(`custom_fields[${i}][id]`, o.id);
                    if (Array.isArray(o.value)) {
                        o.value.forEach((vo, vi) => {
                            if (vo) {
                                data.append(`custom_fields[${i}][value][${vi}]`, vo);
                            }
                        });
                    } else {
                        if (o.value) {
                            data.append(`custom_fields[${i}][value]`, o.value);
                        }
                    }
                });
            }
            else {
                if (item[1]) {
                    if (Array.isArray(item[1])) {
                        item[1].forEach((vo, vi) => {
                            if (vo) {
                                data.append(`${item[0]}[${vi}]`, vo);
                            }
                        });
                    } else {
                        if (item[1]) {
                            data.append(item[0], item[1]);
                        }
                    }
                }
            }
        });

        const url = 'v1/me/update-details';
        return Vue.$axios.$post(url, data);
    },
};
